/**
 * El alta falló porque ESTE dispositivo ya tiene una passkey de la cuenta: el
 * servidor manda `excludeCredentials` con todas las que existen y el navegador
 * responde InvalidStateError si alguna está en su autenticador.
 *
 * No es un error: es el caso de quien ya tenía una passkey (por ejemplo la de
 * Safari/iCloud) y entra por primera vez a un navegador que la ve. La passkey
 * sirve para entrar, así que la entrada rápida se activa igual.
 */
export function esAltaYaRegistrada(err: unknown): boolean {
  return (err as { name?: string } | null)?.name === 'InvalidStateError';
}

/** Qué le decimos a la persona cuando el alta de la passkey no sale. */
export function mensajeDeAltaFallida(err: unknown): string {
  const e = err as { name?: string; message?: string } | null;
  if (e?.name === 'NotAllowedError') {
    return 'Se canceló o este dispositivo no pudo verificarte. Podés reintentar.';
  }
  return e?.message ? `No se pudo activar: ${e.message}` : 'No se pudo activar. Probá de nuevo.';
}
